import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Card } from "reactstrap";
import Divider from '@mui/material/Divider';
import ProjectInfoTab from './projectInfoTab';
// import TaskInfoTab from './taskInfoTab';
import { Modules } from '../../constants/Module';
import { withTranslation } from 'react-i18next';

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 0 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const Documents = (props) => {
    const [value, setValue] = React.useState(Modules.PROJECT);
    const [selectedFiles, setSelectedFiles] = React.useState([]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return (
        <div className='documentsTab'>
            <div className='documentsTabLabel d-flex justify-content-between align-items-center mb-3'>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" className='tabsButton'>
                    <Tab label={props.t("Project Info")} {...a11yProps(0)} value={Modules.PROJECT} />
                    {/* <Tab label={props.t("Task Info")} {...a11yProps(1)}  value={Modules.TICKET} /> */}
                </Tabs>
            </div>
            <CustomTabPanel value={value} index={Modules.PROJECT}>
                <React.Fragment>
                {
                    selectedFiles?.length > 0 ?
                <div className="projectSubmission teamTable customTabCard">
                    <Card className="viewProjectApproval" style={{ height: 500, width: "100%" }}>
                        <div className='mx-5 my-4'>
                        {(selectedFiles.map((file, key) => (
                            <>
                            <div className='d-flex justify-content-around mb-2' key={key}>
                            <span className='me-3 fs-6 fw-semibold text-truncate' style={{width: 150}} title={file.file.name}>{file.file.name}</span>
                            <div className="progress w-75 my-auto">
                                <div
                                    className="progress-bar progress-bar-info progress-bar-striped"
                                    role="progressbar"
                                    aria-valuenow={file.progress}
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                    style={{ width: file.progress + "%" }}
                                >
                                </div>
                            </div>
                                <span className='fs-6 fw-bolder'>{file.progress} %</span>
                            </div>
                            <Divider className='mb-2' variant="fullWidth" sx={{borderBottomColor: 'purple'}}  />
                            </>
                        )))}
                        </div>
                    </Card>
                </div>
                    :
                    (
                        <ProjectInfoTab/>
                    )
                }
                </React.Fragment>
            </CustomTabPanel>
            {/* <CustomTabPanel value={value} index={Modules.TICKET}>
                <TaskInfoTab />
            </CustomTabPanel> */}
        </div>
    );
}

export default withTranslation() (Documents)
